import React, { useState, useEffect } from "react";
import axios from "axios";
import "../css/vehicle.css";
import useAuthRedirect from "../hooks/useAuthRedirect";
import { useParams } from "react-router-dom";

const DcReturnPrint = () => {
  const handlePrint = () => {
    window.print();
  };

  const {dcNo} = useParams();
  const branch = localStorage.getItem("branch");
  const [header, setHeader] = useState({});
  const [data, setData] = useState([]);

  useEffect(() => {
    const fetchIndentDetails = async () => {
      try {
        const response = await axios.get(`https://rfs2.infraconsoft.net.in/api/dcReturn_detailsHeader?dcNo=${dcNo}&branch=${branch}`);
        if (response.data && response.data.headerDetails?.length > 0) {
            const items = response.data.headerDetails;

            const storeReqHeader = {
                dcNumber: items[0].dcreturnheader_number || "N/A",
                branch: items[0].branchCode || "N/A",
                dcDate: items[0].dcreturnheader_date || "N/A",
                type: items[0].dcreturnheader_type || "N/A",
                scode: items[0].dcreturnheader_supplierCode || "N/A",
                sName: items[0].dcreturnheader_supplierName || "N/A",
                refNo: items[0].dcheader_yourReferenceNumber || "N/A",
                refDate: items[0].dcheader_yourReferenceDate || "N/A",
                pack: items[0].dcreturnheader_noofPacks || "N/A",
                vno: items[0].dcheader_vehicleNumber || "N/A",
                remarks: items[0].dcreturnheader_remarks || "N/A",
                address: items[0].dcreturnheader_txtAddress || "N/A",
                city: items[0].dcreturnheader_txtCity || "N/A",
                pincode: items[0].dcreturnheader_txtPincode || "N/A",
                phone: items[0].dcheader_phone || "N/A",
                email: items[0].dcheader_mobile || "N/A",
                user: items[0].userId || "N/A",
            };

            setHeader(storeReqHeader);
        }
      } catch (error) {
        console.error("Error fetching locations:", error);
      }
    };

    fetchIndentDetails();
  }, [dcNo, branch]); 

  useEffect(() => {
    axios.get(`https://rfs2.infraconsoft.net.in/api/dcReturns_bottomDetails?dcNo=${dcNo}&branch=${branch}`)
    .then((response) => {
      setData(response.data.bottomDetails);
      console.log(response.data.bottomDetails);
      
    })
    .catch((error) => {
      console.error("Error fetching vehicles:", error);
    })
}, [dcNo, branch]); 




  return (
    <div className="dc-print-container">
      {/* Header */}
      <div className="dc-header">
        <h1 className="dc-title">Delivery CHALLAN</h1>
        <h2 className="dc-company-name">SRC PROJECTS PRIVATE LIMITED</h2>
        <p className="dc-address">
          HEAVY CIVIL CONSTRUCTORS, 4-B, LAKSHMIPURAM, GANDHI ROAD, SALEM-636 007
        </p>
      </div>

      {/* DC Info */}
      <div className="dc-info">
        <span><strong>DC No:</strong> {header.dcNumber}</span>
        <span><strong>DC Type:</strong> {header.type}</span>
        <span><strong>DC Date:</strong> {header.dcDate ? new Date(header.dcDate).toISOString().split("T")[0] : ""}</span>
      </div>

      {/* From & To Section */}
      <div className="dc-from-to">
        <div className="dc-from">
          <h3>From:</h3>
          <p>SRC PROJECTS PRIVATE LIMITED</p>
          <p>{header.branch}</p>
        </div>
        <div className="dc-to">
          <h3>To:</h3>
          <p>{header.sName}</p>
          <p>{header.address}</p>
          <p>{header.city} - {header.pincode}</p>
        </div>
      </div>

      {/* Table */}
      <table className="dc-table">
        <thead>
          <tr>
          <th>S.No</th>
                    <th>Item Code</th>
                    <th>Part No</th>
                    <th>Item Name</th>
                    <th>UOM</th>
                    <th>Pending Qty</th>
                    <th>Reached Qty</th>
          </tr>
        </thead>
        <tbody>
                  {data.length > 0 ? (
                    data.map((item, index) => (
                      <tr key={index}>
                        <td>{index + 1}</td>
                        <td>{item.dcreturndetail_itemcode}</td>
                        <td>{item.itemmaster_drawingNumber}</td>
                        <td>{item.itemmaster_name}</td>
                        <td>{item.itemmaster_uom}</td>
                        <td>{item.dcreturndetail_DcPendingQuantity}</td>
                        <td>{item.dcreturndetail_Quantity}</td>

                      </tr>
                    ))
                  ) : (
                    <tr>
                      <td colSpan="9">No items</td>
                    </tr>
                  )}
                </tbody>
      </table>

      {/* Footer */}
      <div className="dc-footer">
        <p><strong>Issued by:</strong> {header.user} - {header.branch}</p>
        <p><strong>Sent through:</strong> {header.vno}</p>
        <p><strong>No. of Packs:</strong> {header.pack}</p>
      </div>

      {/* Signature Section */}
      <div className="dc-signature">
        <span>Store Clerk</span>
        <span>Manager</span>
      </div>

      {/* Note */}
      <p className="dc-note">
        The duplicate to be sent to office or origin for confirmation
      </p>

      {/* Print Button */}
      <button className="dc-print-button" onClick={handlePrint}>Print</button>
    </div>
  );
};

export default DcReturnPrint;
